module.exports = __webpack_public_path__ + "img/kong_challenge.6f2b11c6.gif";